import { render, staticRenderFns } from "./ContentFeedItem.vue?vue&type=template&id=aaba9bba&scoped=true&"
import script from "./ContentFeedItem.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedItem.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedItem.vue?vue&type=style&index=0&id=aaba9bba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaba9bba",
  null
  
)

export default component.exports